import dayjs, { Dayjs } from 'dayjs';

const ISO_FORMAT = 'YYYY-MM-DD';
const PADDING_PROBE_DATE = new Date(2006, 0, 2);

const tokenForPart = (type: string, value: string) => {
  if (type === 'year') return 'YYYY';
  if (type === 'month') return value.length === 2 ? 'MM' : 'M';
  if (type === 'day') return value.length === 2 ? 'DD' : 'D';
  return null;
};

/** dayjs reads letters as format tokens, so only a literal holding word characters is [escaped]. */
const literalToken = (value: string) => (/\w/.test(value) ? `[${value}]` : value);

export const buildRegionalDateFormat = (locale: string) => {
  try {
    const parts = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }).formatToParts(PADDING_PROBE_DATE);

    const tokens = parts.map((part) =>
      part.type === 'literal' ? literalToken(part.value) : tokenForPart(part.type, part.value),
    );
    const hasWesternDigits = parts.every(
      (part) => part.type === 'literal' || /^\d+$/.test(part.value),
    );
    if (tokens.includes(null) || !hasWesternDigits) return ISO_FORMAT;
    return tokens.join('');
  } catch {
    return ISO_FORMAT;
  }
};

export const getKeyboardTargetDate = (from: Dayjs, key: string, shiftKey: boolean) => {
  switch (key) {
    case 'ArrowLeft':
      return from.subtract(1, 'day');
    case 'ArrowRight':
      return from.add(1, 'day');
    case 'ArrowUp':
      return from.subtract(1, 'week');
    case 'ArrowDown':
      return from.add(1, 'week');
    case 'PageUp':
      return from.subtract(1, shiftKey ? 'year' : 'month');
    case 'PageDown':
      return from.add(1, shiftKey ? 'year' : 'month');
    default:
      return null;
  }
};

export const formatDateForPicker = (date: Dayjs | null, format: string) =>
  date ? dayjs(date).format(format) : '';
